import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Radio } from 'antd';
import React from 'react';

export enum AppStatusSelectValue {
	all = 'all',
	connected = 'connected',
	installed = 'installed'
}

const options = [
	{
		label: COPY_SPECIFIC.ALL,
		value: AppStatusSelectValue.all
	},
	{
		label: COPY_SPECIFIC.CONNECTED,
		value: AppStatusSelectValue.connected
	},
	{
		label: COPY_SPECIFIC.INSTALLED,
		value: AppStatusSelectValue.installed
	}
];

export interface AppStatusSelectProps {
	onChange: (value: AppStatusSelectValue) => void;
	value: AppStatusSelectValue;
}

export const AppStatusSelect: React.FC<AppStatusSelectProps> = ({ value, onChange }) =>
	<Radio.Group
		block
		buttonStyle='solid'
		onChange={ (e) => onChange(e.target.value as AppStatusSelectValue) }
		options={ options }
		optionType='button'
		style={ { display: 'inherit' } }
		value={ value } />;
